import { useMutation } from "@tanstack/react-query"
import { graphql, type InputOf } from "@/graphql"
import { useGraphQLClient } from "@/lib/blueprint-auth/client"

export const UpdateIndustryConsentMutation = graphql(`
    mutation UpdateIndustryConsent($input: IndustryConsentDataPerSupplyPointInput!) {
        updateIndustryConsentData(input: $input) {
            consentData {
                collectDailyConsumptionData
                collectHalfHourlyConsumptionData
            }
        }
    }
`)

export function useUpdateIndustryConsentMutation() {
    const graphQLClient = useGraphQLClient()

    const updateIndustryConsent = useMutation({
        mutationKey: ["UpdateIndustryConsentMutation"],
        mutationFn: async (input: InputOf<typeof UpdateIndustryConsentMutation>) =>
            await graphQLClient.request(UpdateIndustryConsentMutation, { input }),
    })

    return updateIndustryConsent
}
